<ng-progress color="red" [thick]="true" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>


<div id="manageperpetuals" [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}" *ngIf="perpetuals">
  <div class="pageTitle" id="subBlock">
    {{title}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>
  </div>
  <div class="subBlockContent" style="margin-left:0px">
    <div class="manage_header">
      <input class="manage_search_input" type="text" [(ngModel)]="searchField">
      <div class="manage_search_icon">
        <i class="fas fa-search fa-lg"></i>
      </div>
    </div>
    <div class="manage-body" *ngIf="perpetuals">
      <table class="table table-hover table-dark">
        <thead>
          <tr>
            <th scope="col" style="width: 16%">EU NAME</th>
            <th scope="col" style="width: 14%" class="align-center">PROGRAM TYPE</th>
            <th scope="col" style="width: 14%" class="align-center">CUSTOMER REF</th>
            <th scope="col" style="width: 14%" class="align-center">ORDER DATE</th>
            <th scope="col" style="width: 14%" class="align-center">ORDER NO</th>
            <th scope="col" style="width: 14%" class="align-center">TOTAL</th>
            <th scope="col" style="width: 14%"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let perpetual of perpetuals | paginate: { itemsPerPage: itemsPerPage, currentPage: p, totalItems: totalItems } | TableFilter: 'endUser' : searchField">
            <ng-container>
              <tr>
                <td class="manage-text">{{perpetual?.endUser}}</td>
                <td style="vertical-align: middle; text-align: center;">{{perpetual?.programType}}</td>
                <td style="vertical-align: middle; text-align: center;">{{perpetual?.customerRef}}</td>
                <td style="vertical-align: middle; text-align: center;">{{perpetual?.orderDate}}</td>
                <td style="vertical-align: middle; text-align: center;">{{perpetual?.orderNumber}}</td>
                <td style="vertical-align: middle; text-align: center;">{{perpetual?.totalAmount}}</td>
                <td style="vertical-align: right;">
                  <button class="button button-red button-small button-hover-white" [routerLink]="">Manage</button>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <pagination-controls (pageChange)="p = $event" [directionLinks]="true" previousLabel="" nextLabel="" class="search-pagination"
      *ngIf="showPager"></pagination-controls>
    </div>
  </div>
</div>

<div class="entry-container">
  <router-outlet></router-outlet>
</div>

